function initResponseOptions(responseTypeValue, responseOptionsValue) {
	var options = {};

	switch (responseTypeValue) {
		case "clicks":
			options = clickResponseOptions(responseOptionsValue);
			break;
		case "mic":
			options = micResponseOptions(responseOptionsValue);
			break;
		default:
			options = generalResponseOptions(responseOptionsValue);
			break;
	}

	if(responseOptionsValue.indexOf('waitResponseWindow') >= 0){
		options.waitForResponseWindow = true;
	}

	return options;
}

function generalResponseOptions(responseOptionsRaw) {

	responseOptionsRaw = responseOptionsRaw.toLowerCase();
	var options = {};

	//multiple responses
	var minSelection = responseOptionsRaw.match(/min\s*:\s*(\d+)/);
	var maxSelection = responseOptionsRaw.match(/max\s*:\s*(\d+)/);
	if (minSelection || maxSelection) {
		options.multipleResponses = {
			min: minSelection ? parseInt(minSelection[1], 10) : 1, // at least one response is required
			max: maxSelection ? parseInt(maxSelection[1], 10) : Infinity
		};
	}

	return options;
}

function parseResponseAttribtes(responseOptionsRaw) {
	const allowedTypeAttributes = ['color','date','datetime-local','email','month','number','range','tel','text','time','url','week']
	let responseOptions = responseOptionsRaw.split(';');

	let optionsObject = {};

	for(const option of responseOptions) {
		if(option.match(/\S+ *: *\S+/)) {
			let [attribute, value] = option.split(':');
			attribute = attribute.trim().toLowerCase();
			value = value.trim();
			if(attribute == 'type' && !allowedTypeAttributes.includes(value)) {
				continue;
			}
			optionsObject[attribute] = value.replaceAll('"', '');

		}
	}

	return optionsObject;
}


function clickResponseOptionsForTrial(trialRow) {
	var responseOptionsRaw = columnForTrial('responseOptions', trialRow).toLowerCase();
	return clickResponseOptions(responseOptionsRaw);
}

function clickResponseOptions(responseOptionsRaw) {

 	responseOptionsRaw = responseOptionsRaw.toLowerCase();

	var options = {
		number: 1
	};

	//multiple selection
	var minSelection = responseOptionsRaw.match(/min:(\d+)/);
	if(minSelection) {
		options.multipleClicks = {
			min: parseInt(minSelection[1])
		}
	}
	var maxSelection = responseOptionsRaw.match(/max:(\d+)/);
	if(maxSelection) {
		if(!options.multipleClicks){
			options.multipleClicks = {
				max: parseInt(maxSelection[1])
			}
		}
		else{
			options.multipleClicks.max = parseInt(maxSelection[1]);
		}
	}

	//number
	var clicksNumber = responseOptionsRaw.match(/(^\d+)|(;\d+$)|(;\d+;)/g);
	if (clicksNumber) {
		options.number = parseInt(clicksNumber[0].replace(/^;|;$/gm,''));
	}

	//grid / pixel
	if (responseOptionsRaw.indexOf('pixel') > -1) {
		options.pixel = true;

		if (responseOptionsRaw.indexOf('origin') > -1) {
			options.origin = responseOptionsRaw.split(':')[1].trim();
		}
		
	} else {
		var grid = responseOptionsRaw.match(/grid\((\d+)x(\d+)\)/);
		if (grid) {
			options.grid = {
				rows: parseInt(grid[1]),
				cols: parseInt(grid[2])
			}
		}
	}

	return options;
}

function initResponseRowsLabels(responseRowsValue) {
 	var rows = null;
 	if (responseRowsValue && responseRowsValue != 'na') {
 		rows = responseRowsValue.split(';').filter(function(c) {return c.length != 0});
 	}
  	return rows;
}